import {STRUCTURE_COMPONENT_PROPERTIES_KEYS, type PartialComponentExport} from './constants'
import type {WmlExportFormat} from '@wix/document-services-types'
import _ from 'lodash'
import {generateXmlFile} from './structure/xmlGenerator'
import {generateCssFile} from './style/cssGenerator'
import {generateJsonFile} from './other/jsonGenerator'
import {isVariantSplit} from '../../utils/variants'
import type {DecoratedExportFormat} from '../../types'

export const extractToPartialComponentExport = (componentExport: DecoratedExportFormat): PartialComponentExport => {
    const {rootComponent, components, version, variantsMap, ...otherData} = componentExport
    const exportPerWmlType = _.reduce(
        components,
        (acc, component, id) => {
            _.forOwn(component, (value, key) => {
                let wmlType

                if (isVariantSplit(value)) {
                    wmlType = 'style'
                } else if (!_.isObject(value) || STRUCTURE_COMPONENT_PROPERTIES_KEYS.has(key)) {
                    wmlType = 'structure'
                } else {
                    wmlType = 'other'
                }

                _.set(acc, [wmlType, 'components', id, key], component[key])
            })
            return acc
        },
        {structure: {rootComponent}, other: {}, style: {variantsMap}}
    ) as PartialComponentExport

    exportPerWmlType.other = {...exportPerWmlType.other, ...otherData}
    exportPerWmlType.version = version

    return exportPerWmlType
}

export const exportWml = (componentExport: DecoratedExportFormat): WmlExportFormat => {
    const {structure, other, style, ...otherProps} = extractToPartialComponentExport(componentExport)

    const wmlExport: WmlExportFormat = {
        structure: generateXmlFile(structure),
        data: generateJsonFile(other),
        style: generateCssFile(style),
        ...otherProps
    }

    return wmlExport
}
